import { render, staticRenderFns } from "./OpenCamera.vue?vue&type=template&id=554fd45a"
import script from "./OpenCamera.vue?vue&type=script&lang=js"
export * from "./OpenCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports